import ApolloClient, { createNetworkInterface } from "react-apollo"
import { fetchToken } from "../config/protectedMiddleware"
import { GRAPH_ROUTE, ROUTES } from "./routes"
import { logoutUser } from "../Auth"
import { getLocaleFromCookie } from "../Intl"

const networkInterface = createNetworkInterface({
  uri: ROUTES.get(GRAPH_ROUTE).url
})

networkInterface.use([
  {
    async applyMiddleware(req, next) {
      if (!req.options.headers) {
        req.options.headers = {} // Create the header object if needed.
      }
      try {
        const token = await fetchToken({})
        req.options.headers.authorization = token
          ? `Bearer ${token || ""}`
          : null
      } catch (error) {
        console.log(error)
        logoutUser()
      }
      req.options.headers.locale = getLocaleFromCookie()
      next()
    }
  }
])

networkInterface.useAfter([
  {
    applyAfterware({ response }, next) {
      if (response.status === 401) {
        logoutUser()
      } else if (response.status === 403) {
        logoutUser()
      }
      next()
    }
  }
])

const client = new ApolloClient({ networkInterface })
export default client



// WEBPACK FOOTER //
// ./src/API/client.js